import React from "react";

import { EllipsisOutlined } from "@ant-design/icons";
import { cx } from "class-variance-authority";

import * as theme from "./PaginationEllipsis.css";

export function PaginationEllipsis({
    className,
    ...props
}: React.ComponentProps<"span">) {
    return (
        <span
            aria-hidden
            data-slot="pagination-ellipsis"
            className={cx(theme.ellipsis, className)}
            {...props}
        >
            <EllipsisOutlined />
        </span>
    );
}
